import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";

/**
 * Hook for toggling force password reset flag on users
 */
export const useForcePasswordReset = () => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Update user mutation
  // @ts-ignore - Type checking for trpc.user property
  const updateUserMutation = trpc.user.updateUser.useMutation({
    onSuccess: () => {
      // Invalidate the users queries to refresh data
      // @ts-ignore - Type checking for utils.user property
      utils.user.getUsers.invalidate();
      // @ts-ignore - Type checking for utils.user property
      utils.user.getUserById.invalidate();
    },
  });

  // Function to toggle force password reset with better error handling
  const toggleForcePasswordReset = useCallback(
    async (userId: string, forceReset: boolean) => {
      try {
        await updateUserMutation.mutateAsync({
          id: userId,
          forcePasswordChange: forceReset,
        });
        return { success: true };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to update password reset flag",
        };
      }
    },
    [updateUserMutation],
  );

  return {
    toggleForcePasswordReset,
    isLoading: updateUserMutation.isLoading,
    isError: updateUserMutation.isError,
    error: updateUserMutation.error,
    isSuccess: updateUserMutation.isSuccess,
    reset: updateUserMutation.reset,
  };
};
